import ReactSelect from "react-select";
import {Typography, useTheme} from "@mui/material";

const CustomFilterComponent = (props) => {
    const theme = useTheme();

    const {width, isSearchable, isClearable, filterLabel, filterOptions, filterValue, onChange, isSearchForFilter, isSearchValue, isDisabled} = props;

    const getPlaceholder = () => (
        <>
            {isSearchForFilter ?
                <>
                    <span style={{color: theme.typography.primary, opacity: 0.85}}>
                        Filter:
                    </span> &nbsp;

                    <i style={{color: theme.typography.secondary, opacity: 0.45}}>
                        {filterLabel ? (
                            <Typography sx={{color: "#000", fontSize: 14}}>
                                {filterLabel}
                            </Typography>
                        ) : (
                            "Select Filter"
                        )}
                    </i>
                </>
            :
                <>
                    {filterValue ?
                        <Typography sx={{color: "#000", fontSize: 14}}>
                            {filterValue}
                        </Typography>
                    :
                        <Typography sx={{color: theme.typography.primary, opacity: 0.85, fontSize: 14}}>
                            Search {filterLabel} 
                        </Typography>
                    }
                </>
            }
        </>
    )

    const customStyles = {
        control: (base, state) => ({
            ...base,
            marginRight: "10px",
            height: 42,
            backgroundColor: 'transparent',
            width: width,
            fontSize: 14,
            borderColor: state.isFocused ? theme.palette.primary.main : "#dce8f5",
            boxShadow: state.isFocused ? `0 0 0 1px ${theme.palette.primary.main}` : "none",
            '&:hover': {
                borderColor: theme.palette.primary.main
            }
        }),
        placeholder: base => ({
            ...base,
            fontSize: 14
        }),
        menu: provided => ({
            ...provided,
            zIndex: 99999,
            fontSize: 14
        }),
    }

    return (
        <ReactSelect
            placeholder={getPlaceholder()}
            isSearchable={isSearchable}
            isClearable={isClearable}
            isRtl={false}
            options={filterOptions}
            onChange={onChange}
            styles={customStyles}
            isSearchForFilter={isSearchForFilter}
            isSearchValue={isSearchValue}
            filterLabel={filterLabel}
            isDisabled={isDisabled}
        />
    )
}

export default CustomFilterComponent
